function Tabs() {
  const bindAll = function () {
    const menuElements = document.querySelectorAll("[data-tab]");
    for (let i = 0; i < menuElements.length; i++) {
      menuElements[i].addEventListener("click", change, false);
    }
  };

  const clear = function () {
    const menuElements = document.querySelectorAll("[data-tab]");
    for (let i = 0; i < menuElements.length; i++) {
      menuElements[i].classList.remove("active");
      const id = menuElements[i].getAttribute("data-tab");
      document.getElementById(id).classList.remove("active");
    }
  };

  const change = function (e) {
    clear();
    e.target.classList.add("active");
    const id = e.currentTarget.getAttribute("data-tab");
    const container = document.querySelector(".home__tab");
    container.style.transition = "none";
    const currentTab = document.getElementById(id);
    currentTab.classList.add("active");
  };

  bindAll();
}

window.addEventListener("DOMContentLoaded", (event) => {
  new Swiper(".home__tab .list__collection", {
    slidesPerView: "auto",
    spaceBetween: 20,
    breakpoints: {
      200: {
        slidesPerView: 1.5,
      },
      430: {
        slidesPerView: 1.5,
      },
      800: {
        slidesPerView: 3.5,
      },
      1200: {
        slidesPerView: 4.5,
      },
    },
  });

  new Tabs();
});
